module.exports = __webpack_public_path__ + "static/media/stage1.7d8d5013.svg";